var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-window',{ref:"ppModal",attrs:{"title":_vm.currentAction ? _vm.currentAction.Title : '',"width":"50%","modal":true}},[_c('div',{ref:"ppContent",staticClass:"first-launch-content",staticStyle:{"height":"400px"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-action-close",attrs:{"type":"button"},on:{"click":_vm.onActionClose}},[_vm._v("Закрыть")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467f3eab","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/components/FirstLaunch.vue
// module id = 963
// module chunks = 1